// A small pill showing a flight's / route's rules category: VFR (green), IFR (red) or Mixed (Y/Z,
// green/red split). Shared by the flights list and the routes list so the badge reads the same
// everywhere. Colours match the New Flight / New Route chooser cards.
interface RulesTypeBadgeProps {
  flightRules?: "V" | "I" | "Y" | "Z";
  //route fallback: a saved IFR route may predate the flightRules field — isIfr marks it IFR-family
  isIfr?: boolean;
  style?: React.CSSProperties;
}

function RulesTypeBadge({ flightRules, isIfr, style }: RulesTypeBadgeProps) {
  const mixed = flightRules === "Y" || flightRules === "Z";
  const ifr = !mixed && (flightRules === "I" || (isIfr === true && !flightRules));
  //Mixed shows the actual Z/Y letter; the gradient runs in the direction of the rules change:
  //Z departs VFR → picks up IFR (green→red); Y departs IFR → cancels to VFR (red→green).
  const green = "#198754";
  const red = "#dc3545";
  const label = mixed ? (flightRules as string) : ifr ? "IFR" : "VFR";
  const background = mixed
    ? flightRules === "Z"
      ? `linear-gradient(135deg, ${green} 50%, ${red} 50%)`
      : `linear-gradient(135deg, ${red} 50%, ${green} 50%)`
    : ifr
    ? red
    : green;
  const title = mixed
    ? flightRules === "Z"
      ? "Mixed: departs VFR, picks up IFR (Z)"
      : "Mixed: departs IFR, cancels to VFR (Y)"
    : ifr
    ? "Instrument Flight Rules"
    : "Visual Flight Rules";

  return (
    <span
      title={title}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "1px 8px",
        borderRadius: "999px",
        background,
        color: "#fff",
        fontSize: "0.62rem",
        fontWeight: 700,
        letterSpacing: "0.04em",
        verticalAlign: "text-bottom",
        ...style,
      }}
    >
      {label}
    </span>
  );
}

export default RulesTypeBadge;
